import { defineStore } from 'pinia';

export interface Preis1914InputStore {
  roofHighQuality: boolean;
  exteriorWalls: boolean;
  wallDecorations: boolean;
  floorHighQuality: boolean;
  floorPoorQuality: boolean;
  windowsHighQuality: boolean;
  windowsPoorQuality: boolean;
  doorsHighQuality: boolean;
  bathroomHighQuality: boolean;
  bathroomPoorQuality: boolean;
  heatingHighQuality: boolean;
  heatingPoorQuality: boolean;
}

export const use1914InputStore = defineStore('Preis1914InputStore', {
  state: (): Preis1914InputStore => ({
    roofHighQuality: false,
    exteriorWalls: false,
    wallDecorations: false,
    floorHighQuality: false,
    floorPoorQuality: false,
    windowsHighQuality: false,
    windowsPoorQuality: false,
    doorsHighQuality: false,
    bathroomHighQuality: false,
    bathroomPoorQuality: false,
    heatingHighQuality: false,
    heatingPoorQuality: false,
  }),
});
